import { createAction, props } from '@ngrx/store';
import { Access } from './access.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records access'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records access success', 
    props<{ listData: Access[] }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records access failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record access',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record access success', 
    props<{ singleData: Access }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record access failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state access',
);